<course-details :fetching="fetching" :course-data="courseData"></course-details>